<template>
  <div class="animated fadeIn">
    <basic-heading title="Test Processes" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <test-process-server-table @deleteTestProcess="deleteTestProcess" />
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import TestProcessServerTable from "@/components/lab/testprocess/TestProcessServerTable";
import StatisticTile from "@/components/shared/StatisticTile";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { testProcessNotifications } from "@/shared/notifications";

Vue.use(VueNotifications, notificationOptions);

const TestProcessRepository = LabRepositoryFactory.get("testProcess");

export default {
  name: "TestProcessIndex",
  components: {
    BasicHeading,
    StatisticTile,
    TestProcessServerTable,
    HeaderButtonGroup,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/test-processes/add",
            title: "Add test process",
            variant: "success",
          },
        ],
      };
    },
  },
  methods: {
    async deleteTestProcess(id, ref) {
      try {
        await TestProcessRepository.suspend(id);

        this.deleteSuccess();

        ref.refresh();
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Test Process delete Failed.",
          variant: "danger",
        });
      }
    },
  },
  notifications: testProcessNotifications,
};
</script>
